<footer class="container-fluid py-3 py-lg-4 mt-auto" role="contentinfo">
  <nav class="d-flex flex-column flex-md-row align-items-center gap-3 gap-md-4" aria-label="Fußzeilen-Navigation">
    <a href="https://hilfe.paylife.at/paylife-faq/haeufig-gestellte-fragen"
       target="_blank"
       class="cst-brau info-icon"
       rel="noopener noreferrer"
       tabindex="0"
       aria-label="FAQ - Häufig gestellte Fragen, öffnet in neuem Tab">
      FAQ</a>
    <a href="https://www.paylife.at/paylife/impressum"
       target="_blank"
       class="cst-brau"
       rel="noopener noreferrer"
       tabindex="0"
       aria-label="Impressum, öffnet in neuem Tab">
       Impressum</a>

    <span class="ms-md-auto" role="text" aria-label="Copyright Paylife">&copy; PayLife</span>
  </nav>
</footer>
